import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: `simple-tabpanel-${index}`,
    "aria-labelledby": `simple-tab-${index}`
  }, other), value === index && children);
}
const TabsParent = ({
  list,
  index = 0,
  sx,
  ...props
}) => {
  const [value, setValue] = useState(index);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    setValue(index);
  }, [index]);
  function a11yProps(index) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`
    };
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    sx: {
      width: '100%',
      ...sx
    }
  }, props), /*#__PURE__*/React.createElement(Box, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleChange,
    variant: "scrollable",
    scrollButtons: "auto"
  }, list.map((item, index) => /*#__PURE__*/React.createElement(Tab, _extends({
    key: index,
    label: item.title
  }, a11yProps(index)))))), list.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    key: index,
    index: index
  }, item.content)));
};

export { TabsParent };
